export default {
    allFilterSelected (state) {
        return state.qualityAssuranceList.filters.status.concat(
            state.qualityAssuranceList.filters.test_type,
            state.qualityAssuranceList.filters.passed,
        );
    },
};
